import React from 'react';
import { PrimaryButton, Typography } from 'glints-aries/es/@next';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { useAsyncFn } from 'react-use';

import { StyledModalFooter } from './styles.sc';

interface VerificationSuccessModalFooterProps {
  buttonTitle: MessageDescriptor;
  onClose: () => Promise<void>;
}

export const VerificationSuccessModalFooter = ({
  buttonTitle,
  onClose,
}: VerificationSuccessModalFooterProps) => {
  const [{ loading }, handleClose] = useAsyncFn(onClose, [onClose]);
  return (
    <StyledModalFooter>
      <PrimaryButton onClick={handleClose} loading={loading}>
        <Typography variant="button">
          <FormattedMessage {...buttonTitle} />
        </Typography>
      </PrimaryButton>
    </StyledModalFooter>
  );
};
